import { render, staticRenderFns } from "./ProductSectionDescription.vue?vue&type=template&id=1ad3086e&scoped=true"
import script from "./ProductSectionDescription.vue?vue&type=script&lang=js"
export * from "./ProductSectionDescription.vue?vue&type=script&lang=js"
import style0 from "./ProductSectionDescription.vue?vue&type=style&index=0&id=1ad3086e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad3086e",
  null
  
)

export default component.exports